import React from 'react';
import './index.scss';

import QuestionMarkIcon from 'components/atoms/Icon/QuestionMarkIcon';


const PcPopUp = ({
  title,
  children
}) =>{
  return(
    <div className="PcPopUp">
      <QuestionMarkIcon/>      
      <div className="popUpArea">
        <div className="popUpWrapper">
          <div className="popUpContent">
            <div className="PopUp-Title">
              {title}
            </div>
            <div className="PopUp-Detail">
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default PcPopUp;